import { render } from "./PhotosPopup.vue?vue&type=template&id=80ed2634"
import script from "./PhotosPopup.vue?vue&type=script&lang=js"
export * from "./PhotosPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__